import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, throwError } from 'rxjs';
import {tap} from 'rxjs/operators';
import {RestUrlsConfig} from "@signature-it/ngx-generic/config";

@Injectable({
    providedIn: 'root'
})
export class HomepageService {

  protected getHomepageBannersUrl = `${this.restUrlsConf.appURL}/public/home_page_banners.json`;
  protected getHomepageGroupLinksUrl = `${this.restUrlsConf.appURL}/public/homepage_links.json`;

  constructor(protected http: HttpClient,
              protected restUrlsConf: RestUrlsConfig) { }

  getHomepageBanners(): Observable<any> {
    return this.http.get(this.getHomepageBannersUrl)
        .pipe(tap((res) => res, (error: any) => throwError(error || 'Server error')));
  }

  getHomepageGroupLinks(tag = ''): Observable<any> {
    let url = this.getHomepageGroupLinksUrl;
    if(tag) {
      url = url + `?tag=${tag}`
    }
    return this.http.get(url)
        .pipe(tap((res) => res, (error: any) => throwError(error || 'Server error')));
  }
}
